import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class IncomeReceiptsService {

  private _baseUrl: string = "";
  private _controllerName: string = "";

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "IncomeReceipt"
  }

  // private getHeaders(): HttpHeaders{
  //   return new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.getToken()}`
  //   })
  // }

  insert(payload: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}`, payload).pipe(catchError(this.handleErrors))
  }

  creteLinkPayment(payload: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}/creteLinkPayment`, payload).pipe(catchError(this.handleErrors))
  }

  update(id: number, payload: any): Observable<any> {
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}`, payload).pipe(catchError(this.handleErrors))
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getAll(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/`).pipe(catchError(this.handleErrors))
  }

  getById(id: number, includeInactive: boolean = false): Observable<any> {
    const params = includeInactive ? '?includeInactive=true' : '';
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}${params}`).pipe(catchError(this.handleErrors))
  }

  /**
   * 🆕 Obtiene todos los comprobantes que comparten el mismo PaymentGroupId
   * (cuotas cubiertas por un único pago). Incluye anulados.
   */
  getByPaymentGroup(paymentGroupId: string): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/group/${paymentGroupId}`).pipe(catchError(this.handleErrors))
  }

  getByParticipantAndProject(participantId: number, projectId: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/participant/${participantId}/project/${projectId}`).pipe(catchError(this.handleErrors))
  }

  getPlanRelatedByParticipantAndProject(participantId: number, projectId: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/participant/${participantId}/project/${projectId}/plan-related`).pipe(catchError(this.handleErrors))
  }

  getByProjectId(projectId: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/project/${projectId}`).pipe(catchError(this.handleErrors))
  }

  // 🆕 NUEVOS MÉTODOS PARA ANULACIÓN
  /**
   * Anula un comprobante de ingreso
   * @param id ID del comprobante a anular
   * @param cancellationReason Motivo de la anulación
   * @returns Observable con el resultado de la anulación
   */
  cancelIncomeReceipt(id: number, cancellationReason: string): Observable<any> {
    const payload = { cancellationReason };
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}/cancel`, payload)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Obtiene todos los comprobantes anulados
   * @returns Observable con la lista de comprobantes anulados
   */
  getCancelledIncomeReceipts(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/cancelled`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene TODOS los comprobantes (activos + anulados)
   * @returns Observable con la lista completa de comprobantes
   */
  getAllIncludingCancelled(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/all-including-cancelled`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene comprobantes de ingreso con filtros de fecha
   * @param startDate Fecha de inicio (opcional)
   * @param endDate Fecha de fin (opcional)
   * @param dateType Tipo de fecha: "Creation" o "Payment" (por defecto "Creation")
   * @param includeCancelled Incluir comprobantes anulados (por defecto false)
   * @returns Observable con la lista filtrada de comprobantes
   */
  getIncomeReceiptsWithDateFilter(startDate?: Date, endDate?: Date, dateType: string = 'Creation', includeCancelled: boolean = false): Observable<any> {
    let params = new URLSearchParams();

    if (startDate) {
      params.append('startDate', startDate.toISOString());
    }
    if (endDate) {
      params.append('endDate', endDate.toISOString());
    }
    if (dateType) {
      params.append('dateType', dateType);
    }
    params.append('includeCancelled', includeCancelled.toString());

    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/filtered?${params.toString()}`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene comprobantes de ingreso con paginación, búsqueda y filtros del lado servidor
   */
  getIncomeReceiptsPaged(parameters: any): Observable<any> {
    let params = new HttpParams();

    // Paginación
    if (parameters.pageNumber !== undefined && parameters.pageNumber !== null) {
      params = params.append('pageNumber', parameters.pageNumber.toString());
    }
    if (parameters.pageSize !== undefined && parameters.pageSize !== null) {
      params = params.append('pageSize', parameters.pageSize.toString());
    }

    // Búsqueda
    if (parameters.searchTerm) {
      params = params.append('searchTerm', parameters.searchTerm);
    }

    // Ordenamiento
    if (parameters.sortBy) {
      params = params.append('sortBy', parameters.sortBy);
    }
    if (parameters.sortOrder) {
      params = params.append('sortOrder', parameters.sortOrder);
    }

    // Filtros de fecha
    if (parameters.startDate) {
      params = params.append('startDate', parameters.startDate.toISOString());
    }
    if (parameters.endDate) {
      params = params.append('endDate', parameters.endDate.toISOString());
    }
    if (parameters.dateType) {
      params = params.append('dateType', parameters.dateType);
    }

    // Filtros de estado
    if (parameters.cancellationFilter) {
      params = params.append('cancellationFilter', parameters.cancellationFilter);
    }

    // Filtros específicos - usar verificación más segura para números
    if (parameters.paymentMethodId !== undefined && parameters.paymentMethodId !== null) {
      params = params.append('paymentMethodId', parameters.paymentMethodId.toString());
    }
    if (parameters.isManualPayment !== undefined && parameters.isManualPayment !== null) {
      params = params.append('isManualPayment', parameters.isManualPayment.toString());
    }
    if (parameters.payerType) {
      params = params.append('payerType', parameters.payerType);
    }
    if (parameters.projectId !== undefined && parameters.projectId !== null) {
      params = params.append('projectId', parameters.projectId.toString());
    }
    if (parameters.participantId !== undefined && parameters.participantId !== null) {
      params = params.append('participantId', parameters.participantId.toString());
    }
    if (parameters.companyId !== undefined && parameters.companyId !== null) {
      params = params.append('companyId', parameters.companyId.toString());
    }

    // Filtro por ID
    if (parameters.filterId !== undefined && parameters.filterId !== null) {
      params = params.append('filterId', parameters.filterId.toString());
    }

    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/paged`, { params })
      .pipe(catchError(this.handleErrors));
  }

  // 🆕 MÉTODOS PARA VERSIONADO Y APROBACIÓN

  /**
   * Crea una versión editada de un comprobante de ingreso.
   * La nueva versión queda en estado PendingApproval.
   * @param originalId ID del comprobante original
   * @param payload Datos del comprobante editado + justificación
   */
  createEditedVersion(originalId: number, payload: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}/${originalId}/edit`, payload)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Aprueba o rechaza una versión pendiente de comprobante.
   * @param receiptId ID del comprobante pendiente
   * @param action 'Approve' o 'Reject'
   * @param notes Notas opcionales para la aprobación/rechazo
   */
  processApproval(receiptId: number, action: string, notes: string = ''): Observable<any> {
    const payload = { action, notes };
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${receiptId}/approval`, payload)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Obtiene todos los comprobantes pendientes de aprobación.
   */
  getPendingApprovals(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/pending-approvals`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Obtiene el historial completo de versiones de un comprobante.
   */
  getVersionHistory(receiptId: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${receiptId}/versions`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Descarga el PDF del comprobante de ingreso
   * @param id ID del comprobante
   * @returns Observable con el archivo Blob
   */
  downloadPdf(id: number): Observable<Blob> {
    return this._http.get(`${this._baseUrl}/${this._controllerName}/${id}/pdf`, { responseType: 'blob' })
      .pipe(catchError(this.handleErrors));
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Ocurrio un error", error.error.message);
    } else {
      console.log(`${error.status}, ${error.error}`);
      return throwError(() => new Error(`Ocurrio un error ${error.status}, ${error.error}`));
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }

}
